<template>
  <of-dialog :title="formTitle" @onCancel="cancel" :width="width">
    <div slot="content">
      <el-form ref="form" label-width="120px" :model="dataForm">
        <el-form-item label="讲座主题：">
          <p>{{dataForm.TrainTitle}}</p>
        </el-form-item>
        <el-form-item label="培训时间：">
          <p>{{ (dataForm.TrainTime * 1000) | formatDate }}</p>
        </el-form-item>
        <el-form-item label="培训地址：">
          <p>{{dataForm.Address}}</p>
        </el-form-item>
        <el-form-item label="企业名称：">
          <p>{{dataForm.Name}}</p>
        </el-form-item>
        <el-form-item label="联系人：">
          <p>{{dataForm.ContactUser}}</p>
        </el-form-item>
        <el-form-item label="联系电话：">
          <p>{{dataForm.Phone}}</p>
        </el-form-item>
        <el-form-item label="总费用：">
          <p>{{dataForm.Amount ? dataForm.Amount : '免费'}}</p>
        </el-form-item>
        <el-form-item label="企业性质：">
          <p>{{CompanyNature(dataForm.CompanyNature)}}</p>
        </el-form-item>
        <el-form-item label="是否已支付：" >
          <p v-if="dataForm.Amount !==0">{{IsPay(dataForm.IsPay)}}</p>
          <p v-else>否</p>
        </el-form-item>
      </el-form>
    </div>
  </of-dialog>
</template>
<script>
import OfDialog from "@/components/controls/of_dialog/of_dialog";
import { saveAs } from "file-saver";

export default {
  name: "edit",
  props: {
    dataForm: {
      type: Object,
      default: null
    },
    formTitle: {
      type: String,
      default: ""
    },
    isDisabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isdisabled: false,
      width: "35%"
    };
  },
  mounted() {},
  components: {
    OfDialog
  },
  computed: {
    IsPay() {
      return data => {
        return data===1?'是':'否'
      }
    },
    CompanyNature() {
      return data => {
        switch(data) {
          case 0:
            return '团体会员'
          case 1:
            return '非团体会员'
          case 2:
            return '盈利性企业'
          case 3:
            return '非盈利性企业（社区/学校/）'
        }
      }
    }
  },
  methods: {
    //取消
    cancel() {
      this.$emit("formCallBack", null);
    }
  }
};
</script>


<style scoped>
.bg {
  background-color: #f2f2f2;
}
.el-form >>> .el-form-item {
  margin-bottom: 0;
}
.el-dialog__wrapper >>> .el-dialog .el-dialog__footer .el-button--primary {
  display: none;
}
</style>
